export const GoogleMapApiConfig = 'AIzaSyALq4GcHf2BkuXHD8MYWsA6qqnRAPCqrWw';